import { render, staticRenderFns } from "./AppLegend.vue?vue&type=template&id=96911432&scoped=true"
import script from "./AppLegend.vue?vue&type=script&lang=js"
export * from "./AppLegend.vue?vue&type=script&lang=js"
import style0 from "./AppLegend.vue?vue&type=style&index=0&id=96911432&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96911432",
  null
  
)

export default component.exports